import { IDeviceState } from "@/redux/interfaces/IDevice";
import { DeviceActionTypes, ISetDeviceInfoAction } from "@/redux/reducers/deviceReducer";

export const setDeviceInfo = (deviceInfo: Partial<IDeviceState>): ISetDeviceInfoAction => ({
    type: DeviceActionTypes.SET_DEVICE_INFO,
    deviceInfo,
});
